// loader.interceptor.ts
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { AuthService } from './auth.service';

/** Request context flag: do not show the global loader for this call. */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

let totalRequests = 0;

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_GLOBAL_LOADER)) return next(req);
  const commonService = inject(AuthService);
  totalRequests++;
  commonService.show();

  return next(req).pipe(
    finalize(() => {
      totalRequests--;
      if (totalRequests === 0) {
        commonService.hide();
      }
    })
  );
};
